import { Outlet } from 'react-router-dom'
import { AppHeader } from './AppHeader'

/** Layout for supplier/client areas: header + routed content (dashboard, detail). */
export function RoleLayout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <main className="p-4 sm:p-6">
        <Outlet />
      </main>
    </div>
  )
}
